import React, { useState, useRef, useLayoutEffect, PropsWithChildren } from "react";
import "./ExpanderStyles.scss";
import { useWindowDimensions } from "hooks/WindowDimensionsHook";

type Props = {
    // The header is the element you can click on the expand the section, alternatively you can create a custom header to suit your needs using the isExpandedState prop
    header?: React.ReactNode;
    containerClassName?: string;
    innerContainerClassName?: string;
    isExpandedState?: { isExpanded: boolean; setIsExpanded: (x: boolean) => void };
    // This is needed as the height of the container taken from window.innerHeight excludes the height of the border
    borderWidthCorrection?: number;
};

export const Expander: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [height, setHeight] = useState(0);
    const ref = useRef<HTMLDivElement | null>(null);
    const windowDimensions = useWindowDimensions();

    // Update the height variable as the width of the window changes and the layout changes
    useLayoutEffect(() => {
        const current = ref?.current;
        if (current) {
            setHeight(current.clientHeight);
        }
    }, [windowDimensions.width]);

    // state overrides, this way the state can be managed internally or externally according to needs
    const expanded = props.isExpandedState?.isExpanded ? props.isExpandedState.isExpanded : isExpanded;
    const setExpanded = props.isExpandedState?.setIsExpanded ? props.isExpandedState.setIsExpanded : setIsExpanded;

    return (
        <div className={props.containerClassName}>
            {props.header ? (
                <div className="expander-header" onClick={() => setExpanded(!expanded)}>
                    {props.header}
                </div>
            ) : (
                <></>
            )}

            <div className={"expander-body"} style={{ height: (expanded ? height + (props.borderWidthCorrection ?? 0) : 0) + "px" }}>
                <div>
                    <div ref={ref} className={`row expander-body--inner ${props.innerContainerClassName}`}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};
